import { createSlice } from '@reduxjs/toolkit';
import { calculate, close, submitShipping, unsubmitShipping } from '../actions';
import { PACKAGE_NAME, SHIPPING_IS_SUBMITTED_STORAGE_KEY } from '../constants';
import { RootState, ViewID } from '../types';
import { cartApi } from '@reliv/redux-global-cart';

const slice = createSlice({
    name: `${PACKAGE_NAME}/view`,
    initialState: (
        JSON.parse(
            window.localStorage.getItem(SHIPPING_IS_SUBMITTED_STORAGE_KEY)
        ) ?
            ViewID.PRODUCTS :
            ViewID.SHIPPING
    ) as ViewID,
    reducers: {},
    extraReducers: (build) => build
        .addCase(calculate, () => ViewID.RESULTS)
        .addCase(close, () => ViewID.PRODUCTS)
        .addCase(submitShipping, () => ViewID.PRODUCTS)
        .addCase(unsubmitShipping, () => ViewID.SHIPPING)
        .addMatcher(
            cartApi.endpoints.currentOrderAddItems.matchPending,
            () => ViewID.ADD_TO_CART_STATUS
        )
});

export default slice.reducer;
export const { name } = slice;

export const selectView = (state: RootState) => state[slice.name];

export const selectViewIsShippingSubmitted = (state: RootState) => (state[slice.name] !== ViewID.SHIPPING);
